import createAuthUrl from './create-auth-url';
import * as Auth0 from './auth0';

export default redirectPath => {
  let url = createAuthUrl('login', redirectPath);
  if (Auth0.isEnabled) {
    url = Auth0.getLoginUrl(redirectPath);
  }
  window.location.assign(url);
};
